export default __webpack_public_path__ + "static/media/casaduana_LogoPrincipal.52d0de49.png";